<div class="aca-admin aca-shl">
  <aca-page-header icon="share" [title]="'DMS.SHARELINKS.TITLE' | translate" [subtitle]="'DMS.SHARELINKS.SUBTITLE' | translate">
    <button type="button" class="aca-shl__outline" (click)="reload()" [disabled]="loading()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.SHARELINKS.REFRESH' | translate }}
    </button>
  </aca-page-header>

  <!-- ── at a glance ────────────────────────────────────────────────────── -->
  <div class="aca-shl__tiles" *ngIf="!failed()">
    <div class="aca-shl__tile">
      <span class="aca-shl__tilevalue">{{ counts().total | number }}</span>
      <span class="aca-shl__tilelabel">{{ 'DMS.SHARELINKS.TILE_TOTAL' | translate }}</span>
    </div>
    <button
      type="button"
      class="aca-shl__tile aca-shl__tile--warn"
      [class.aca-shl__tile--on]="stateFilter() === 'none'"
      (click)="stateFilter.set(stateFilter() === 'none' ? 'all' : 'none')"
    >
      <span class="aca-shl__tilevalue">{{ counts().none | number }}</span>
      <span class="aca-shl__tilelabel">{{ 'DMS.SHARELINKS.TILE_NONE' | translate }}</span>
    </button>
    <button
      type="button"
      class="aca-shl__tile aca-shl__tile--soon"
      [class.aca-shl__tile--on]="stateFilter() === 'soon'"
      (click)="stateFilter.set(stateFilter() === 'soon' ? 'all' : 'soon')"
    >
      <span class="aca-shl__tilevalue">{{ counts().soon | number }}</span>
      <span class="aca-shl__tilelabel">{{ 'DMS.SHARELINKS.TILE_SOON' | translate: { days: expiringDays } }}</span>
    </button>
    <div class="aca-shl__tile">
      <span class="aca-shl__tilevalue">{{ opensKnown() ? (counts().opens | number) : '—' }}</span>
      <span class="aca-shl__tilelabel">{{ 'DMS.SHARELINKS.TILE_OPENS' | translate }}</span>
    </div>
  </div>

  <!-- ── toolbar ────────────────────────────────────────────────────────── -->
  <div class="aca-shl__toolbar">
    <div class="aca-shl__scope" role="tablist">
      <button type="button" role="tab" class="aca-shl__scopebtn" [class.aca-shl__scopebtn--on]="scope() === 'mine'" (click)="setScope('mine')">
        {{ 'DMS.SHARELINKS.SCOPE_MINE' | translate }}
      </button>
      <button type="button" role="tab" class="aca-shl__scopebtn" [class.aca-shl__scopebtn--on]="scope() === 'all'" (click)="setScope('all')">
        {{ 'DMS.SHARELINKS.SCOPE_ALL' | translate }}
      </button>
    </div>
    <label class="aca-shl__search">
      <mat-icon>search</mat-icon>
      <input type="search" [placeholder]="'DMS.SHARELINKS.SEARCH' | translate" [ngModel]="query()" (ngModelChange)="query.set($event)" />
    </label>
    <select
      class="aca-shl__select"
      [ngModel]="stateFilter()"
      (ngModelChange)="stateFilter.set($event)"
      [attr.aria-label]="'DMS.SHARELINKS.COL_EXPIRY' | translate"
    >
      <option value="all">{{ 'DMS.SHARELINKS.FILTER_ALL' | translate }}</option>
      <option value="none">{{ 'DMS.SHARELINKS.STATE_NONE' | translate }}</option>
      <option value="soon">{{ 'DMS.SHARELINKS.STATE_SOON' | translate }}</option>
      <option value="active">{{ 'DMS.SHARELINKS.STATE_ACTIVE' | translate }}</option>
      <option value="expired">{{ 'DMS.SHARELINKS.STATE_EXPIRED' | translate }}</option>
    </select>
  </div>

  <p class="aca-shl__note" *ngIf="!opensKnown() && !loading() && rows().length">
    <mat-icon>info</mat-icon>{{ 'DMS.SHARELINKS.OPENS_UNAVAILABLE' | translate }}
  </p>
  <p class="aca-shl__note" *ngIf="truncated()"><mat-icon>info</mat-icon>{{ 'DMS.SHARELINKS.TRUNCATED' | translate: { count: rows().length } }}</p>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.SHARELINKS.LOAD_FAILED' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.SHARELINKS.REFRESH' | translate"
    (action)="reload()"
  />

  <aca-page-state
    *ngIf="!failed() && !loading() && !visible().length"
    state="empty"
    icon="link_off"
    [title]="(rows().length ? 'DMS.SHARELINKS.EMPTY_FILTER' : 'DMS.SHARELINKS.EMPTY') | translate"
    [message]="'DMS.SHARELINKS.EMPTY_HINT' | translate"
  />

  <!-- ── table ──────────────────────────────────────────────────────────── -->
  <section class="aca-shl__card" *ngIf="!failed() && visible().length">
    <div class="aca-shl__tablewrap">
      <table class="aca-shl__table">
        <thead>
          <tr>
            <th class="aca-shl__th aca-shl__th--name">{{ 'DMS.SHARELINKS.COL_NAME' | translate }}</th>
            <th class="aca-shl__th">{{ 'DMS.SHARELINKS.COL_BY' | translate }}</th>
            <th class="aca-shl__th">{{ 'DMS.SHARELINKS.COL_EXPIRY' | translate }}</th>
            <th class="aca-shl__th aca-shl__th--num">{{ 'DMS.SHARELINKS.COL_OPENS' | translate }}</th>
            <th class="aca-shl__th aca-shl__th--actions">{{ 'DMS.SHARELINKS.COL_ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-shl__row" *ngFor="let row of visible(); trackBy: trackById">
            <td class="aca-shl__td aca-shl__td--name">
              <button type="button" class="aca-shl__name" (click)="openDocument(row)" [matTooltip]="'DMS.SHARELINKS.OPEN_DOC' | translate">
                {{ row.name }}
              </button>
            </td>
            <td class="aca-shl__td">{{ row.sharedBy || '—' }}</td>
            <td class="aca-shl__td">
              <span class="aca-shl__chip" [ngClass]="'aca-shl__chip--' + row.state">{{ stateKey(row) | translate }}</span>
              <span class="aca-shl__sub" *ngIf="row.expiresAt">
                {{ row.expiresAt | acaDate: 'd MMM y' }}
                <ng-container *ngIf="row.state === 'soon'"> · {{ 'DMS.SHARELINKS.DAYS_LEFT' | translate: { days: daysLeft(row) } }}</ng-container>
              </span>
            </td>
            <td class="aca-shl__td aca-shl__td--num">
              <ng-container *ngIf="opensKnown(); else noCount">
                <span class="aca-shl__count">{{ row.opens ?? 0 | number }}</span>
                <span class="aca-shl__sub" *ngIf="row.lastOpenedAt"
                  >{{ 'DMS.SHARELINKS.LAST_OPENED' | translate }} {{ row.lastOpenedAt | acaDate: 'd MMM y HH:mm' }}</span
                >
              </ng-container>
              <ng-template #noCount>—</ng-template>
            </td>
            <td class="aca-shl__td aca-shl__td--actions">
              <button
                mat-icon-button
                class="aca-shl__iconaction"
                (click)="copy(row)"
                [matTooltip]="'DMS.SHARELINKS.COPY' | translate"
                [attr.aria-label]="'DMS.SHARELINKS.COPY' | translate"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
              <a
                mat-icon-button
                class="aca-shl__iconaction"
                [href]="urlOf(row)"
                target="_blank"
                rel="noopener"
                [matTooltip]="'DMS.SHARELINKS.OPEN_PUBLIC' | translate"
              >
                <mat-icon>open_in_new</mat-icon>
              </a>
              <button
                mat-icon-button
                class="aca-shl__iconaction aca-shl__iconaction--danger"
                (click)="revoke(row)"
                [disabled]="revoking() === row.id"
                [matTooltip]="'DMS.SHARELINKS.REVOKE' | translate"
                [attr.aria-label]="'DMS.SHARELINKS.REVOKE' | translate"
              >
                <mat-icon>link_off</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
